import React from 'react';

import { Select } from 'antd';

import { useActiveShowSeasons } from '@hooks/API/ShowSeasons/UseShowSeasons';

import NwSelect from '@components/Gui/NwForm/CustomSelect';

import { getSeasonDisplayName } from '@containers/Booking/ShowSeasons/showSeasonsHelpers';

const ShowSeasonSelector = ({ value, onChange, emptyValue = false, disabled, allowClear = false }) => {
    const { data: activeShowSeasons, isFetching } = useActiveShowSeasons();

    if (!activeShowSeasons?.length) {
        return null;
    }

    return (
        <NwSelect
            width="100%"
            value={value ? value : emptyValue ? null : undefined}
            label="Show season"
            style={{ width: '100%', minWidth: '200px' }}
            placeholder="Select show season"
            onChange={onChange}
            allowClear={allowClear}
            disabled={disabled || (isFetching && !activeShowSeasons.length)}
            getPopupContainer={(triggerNode) => triggerNode.parentNode}
            optionLabelProp="label"
        >
            {emptyValue ? (
                <Select.Option value={null} label="Select a season">
                    Select a season
                </Select.Option>
            ) : null}
            {activeShowSeasons.map((season) => {
                const displayName = getSeasonDisplayName(season);

                return (
                    <Select.Option key={season.ID} value={season.ID} label={displayName}>
                        {displayName}
                    </Select.Option>
                );
            })}
        </NwSelect>
    );
};

export default ShowSeasonSelector;
